<div class="session-expired-backdrop">
  <div class="session-expired-card">
    <div class="session-expired-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 7v5l3 3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h2>{{ ((titleKey$ | async) ?? 'sessionExpired.title') | translate }}</h2>
    <p>{{ ((messageKey$ | async) ?? 'sessionExpired.message') | translate }}</p>
    <button type="button" class="primary-btn" (click)="goToLogin()">
      {{ 'sessionExpired.action' | translate }}
    </button>
  </div>
</div>
